/**
 * Validadores puros y reutilizables para los formularios (Fase 5, robustez). No dependen de
 * React: reciben valores y devuelven booleanos o el primer problema legible. Sirven para
 * deshabilitar el botón de envío Y explicar al usuario qué falta.
 */

/** Texto no vacío tras recortar espacios. */
export const isFilled = (v: string): boolean => v.trim().length > 0;
/** Longitud mínima (tras recortar). */
export const minLen = (v: string, n: number): boolean => v.trim().length >= n;
/** Número finito > 0 (para precios, costos, montos). */
export const isPositiveAmount = (v: string | number): boolean => { const n = Number(v); return Number.isFinite(n) && n > 0; };
/** Entero finito > 0 (para cantidades). */
export const isPositiveInt = (v: string | number): boolean => { const n = Number(v); return Number.isFinite(n) && n > 0 && Number.isInteger(n); };
/** Número finito >= 0 (para stock/existencia inicial). */
export const isNonNegative = (v: string | number): boolean => { const n = Number(v); return Number.isFinite(n) && n >= 0; };
/** Número finito dentro de [min, max]. */
export const withinRange = (v: string | number, min: number, max: number): boolean => { const n = Number(v); return Number.isFinite(n) && n >= min && n <= max; };

/** Regla de formulario: condición + mensaje que se muestra cuando NO se cumple. */
export interface Rule { readonly ok: boolean; readonly msg: string }

/** Devuelve los mensajes de las reglas incumplidas, en orden. */
export function problems(rules: readonly Rule[]): string[] {
  return rules.filter((r) => !r.ok).map((r) => r.msg);
}

/** Primer problema (o null si todo válido). Útil para un hint compacto junto al botón. */
export function firstProblem(rules: readonly Rule[]): string | null {
  return problems(rules)[0] ?? null;
}
